exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option_button[data-v-b4aefba8]{background-color:#fff!important;color:var(--v-gray-base)!important;border:1px solid var(--v-gray-base);min-width:0;max-width:35px;min-height:35px;padding-left:10px}.custom_flat_button[data-v-b4aefba8]{-webkit-box-shadow:none!important;box-shadow:none!important}.option_button[data-v-b4aefba8]:focus,.option_button[data-v-b4aefba8]:hover{border-color:var(--v-primary-base);color:transparent}.option_button:focus i[data-v-b4aefba8],.option_button:hover i[data-v-b4aefba8]{color:var(--v-primary-base)}.custom-border[data-v-b4aefba8]{border-radius:.5rem}", ""]);

// exports
